export enum AssistanceApplicationDenialReason {
    OverIncome = 'OverIncome',
    DuplicateHouseholdSubmission = 'DuplicateHouseholdSubmission',
    Unresponsive = 'Unresponsive',
    DuplicateIndividualSubmission = 'DuplicateIndividualSubmission',
    ProgramClosed = 'ProgramClosed',
    Cancelled = 'Cancelled',
    Other = 'Other'
}
